import React from 'react'
import { Outlet } from 'react-router-dom'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import GroupsCollectionsBootstrap from 'modules/posts/lib/GroupsCollectionsBootstrap'
import NpsCollectionsBootstrap from 'modules/posts/lib/NpsCollectionsBootstrap'
import PostsCollectionsBootstrap from 'modules/posts/lib/PostsCollectionsBootstrap'

type Kind = 'posts' | 'nps' | 'groups'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const BOOTSTRAP: Record<Kind, React.ComponentType<any>> = {
  posts: PostsCollectionsBootstrap,
  nps: NpsCollectionsBootstrap,
  groups: GroupsCollectionsBootstrap,
}

type Prop = {
  kind: Kind
}

const RootPage = ({ kind }: Prop) => {
  const CollectionsBootstrap = BOOTSTRAP[kind]

  return (
    <ResponsivePage>
      <CollectionsBootstrap>
        <Outlet />
      </CollectionsBootstrap>
    </ResponsivePage>
  )
}

export default RootPage
